import React, { useState, useEffect } from 'react'
import NotificationEntrys from './NotificationEntrys'
import './notifications.css'
import { useStore } from '../../../app/stores/store'
import { observer } from 'mobx-react-lite'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Badge, Tooltip } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useDetectClickOutside } from 'react-detect-click-outside'

function NotificationBell() {
  const { notificationsStore } = useStore()
  const { notifications, countNotifications, handleMarkAllAsRead } = notificationsStore
  const [isVisible, setIsVisible] = useState(false)
  const ref = useDetectClickOutside({
    onTriggered: () => setIsVisible(false),
    disableTouch: true,
  })

  useEffect(() => {
    notificationsStore.getNotifications()
  }, [])

  return (
    <>
      <div ref={ref} className='notification-bell'>
        <span role='img' aria-label='notifications' onClick={() => setIsVisible((prev) => !prev)}>
          <Badge badgeContent={countNotifications()} color='secondary' max={99}>
            <NotificationsIcon className='notification-icon' />
          </Badge>
        </span>
        {isVisible && (
          <div className='notification-hub'>
            <header>
              <h6>Notifications</h6>

              <Tooltip
                className='notification-check'
                onClick={() => handleMarkAllAsRead()}
                title='Mark all as read'
              >
                <CheckCircleIcon color='secondary' />
              </Tooltip>
            </header>
            <ul className='notification-scrollbar'>
              {notifications.length > 0 ? (
                notifications
                  .slice()
                  .sort((a, b) => b.date.seconds - a.date.seconds)
                  .map((notif: any, index: number) => (
                    <NotificationEntrys key={index} notification={notif} />
                  ))
              ) : (
                <p className='text-center pt-2'>No Notifications</p>
              )}
            </ul>
          </div>
        )}
      </div>
    </>
  )
}

export default observer(NotificationBell)
